import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import posthog from 'posthog-js';

function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { forgotPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      return setError("Please enter your email");
    }

    try {
      setError("");
      setMessage("");
      setLoading(true);
      await forgotPassword(email);
      setMessage("Password reset request has been sent to the administrator");
      setTimeout(() => navigate("/login"), 3000);
    } catch (err) {
      posthog.captureException(err, {
        tags: {
          service: 'forgot_password_page',
          operation: 'forgot_password',
          user_email: email
        },
        extra: {
          error_message: err.message
        }
      });
      setError("Failed to process request: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Reset Password</h2>
        {error && <div className="auth-error">{error}</div>}
        {message && <div className="auth-success">{message}</div>}
        <form onSubmit={handleSubmit}>
          <p style={{ marginBottom: "20px", textAlign: "center" }}>
            Enter your email below to request a password reset from the
            administrator.
          </p>
          <div className="form-group">
            <label>Your Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your email"
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Sending Request..." : "Request Password Reset"}
          </button>
        </form>
        <div className="auth-links">
          <Link to="/login">Back to Login</Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
